import store from '../store';

export default function (to, from, next) {
    store.state.auth.authenticated ? next() : next({name: 'login'});
}